import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const LineGraph = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} width="13" height="16" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M5.76316 94.9302H100.5V100.193H0.5V0.193359H5.76316V94.9302ZM90.5503 16.9703L94.6602 20.2585L72.2786 48.2354L51.2259 37.7091L31.5023 62.3638L27.3925 59.0756L49.7741 31.0987L70.8267 41.625L90.5503 16.9703Z"
        style={{ fill: color, stroke: color, strokeMiterlimit: 10 }}
      />
    </svg>
  );
};

export default LineGraph;
